import { Component, Inject, OnInit } from '@angular/core';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';

import { SocialLoginService } from '../services/social-login.service';

@Component({
    selector: 'odd-social-login',
    templateUrl: './social-login.component.html',
    styleUrls: [ './social-login.component.scss' ],
})

export class SocialLoginComponent implements OnInit {
    constructor(
        @Inject('Socials') public readonly socials,
        private readonly service: SocialLoginService,
    ) {}

    public ngOnInit(): void {
        this.service.checkAuthState();
    }

    public signInWithGoogle(): void {
        this.service.signIn(GoogleLoginProvider.PROVIDER_ID);
    }

    public signInWithFB(): void {
        this.service.signIn(FacebookLoginProvider.PROVIDER_ID);
    }

    public signInWithGitHub(): void {
        this.service.signInGitHub(this.socials.gitHub.clientId);
    }
}
